'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { CreatorCardSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/CreatorCard';
import CreatorsList from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/CreatorsList';
import OtherSearchedFor from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/OtherSearchedFor';
import { RoomCardSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/RoomCard';
import SearchFilterTags from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchFilterTags';
import { useSearchPageContext } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchPageContext';
import SearchToolbar from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchToolbar';
import WorldsList from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/WorldsList';
import { Separator } from '@/components/ui/separator';
import ViverseSkeleton from '@/components/ViverseSkeleton';
import { SEARCH_PARAM_KEYS } from '@/constants/search';
import { useRouteChangeContext } from '@/context/RouteChangeContext';
import { useUAContext } from '@/context/UAContext';
import useHash from '@/hooks/useHash';
import { createSuggestionWorlds, isValidTab, replaceUrlWithQueryString, SearchResultTab } from '@/lib/search';
type SearchResultProps = {
  hiddenToolbar?: boolean;
  filterModalTopOffset?: number;
};
export default function SearchResult(t0) {
  const $ = _c(48);
  const {
    hiddenToolbar,
    filterModalTopOffset
  } = t0;
  const {
    isMobileApp
  } = useUAContext();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hash = useHash();
  const {
    setIsRouteLoading
  } = useRouteChangeContext();
  const {
    otherSearchedFor,
    gamesTags,
    videosTags
  } = useSearchPageContext();
  let t1;
  if ($[0] !== searchParams) {
    const tabParam = searchParams.get(SEARCH_PARAM_KEYS.TAB) || "top";
    t1 = isValidTab(tabParam) ? tabParam : "top";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeTab = t1;
  let t2;
  if ($[2] !== activeTab || $[3] !== hash || $[4] !== pathname || $[5] !== router || $[6] !== searchParams || $[7] !== setIsRouteLoading) {
    t2 = tab => {
      if (tab === activeTab) {
        return;
      }
      setIsRouteLoading(true);
      const params = new URLSearchParams(searchParams.toString());
      if (tab === "top") {
        params.delete(SEARCH_PARAM_KEYS.TAB);
      } else {
        params.set(SEARCH_PARAM_KEYS.TAB, tab);
      }
      const queryString = params.toString();
      replaceUrlWithQueryString(router, pathname, queryString, hash);
    };
    $[2] = activeTab;
    $[3] = hash;
    $[4] = pathname;
    $[5] = router;
    $[6] = searchParams;
    $[7] = setIsRouteLoading;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleTabChange = t2;
  const showTop = activeTab === "top";
  const showGames = activeTab === "games" || showTop;
  const showExperiences = activeTab === "experiences" || showTop;
  const showCreators = activeTab === "creators" || showTop;
  const showVideos = activeTab === "videos" || showTop;
  const effectiveHiddenToolbar = isMobileApp ? hiddenToolbar : showTop || activeTab === "creators" || hiddenToolbar;
  let t3;
  if ($[9] !== activeTab || $[10] !== handleTabChange) {
    t3 = <div className="no-scrollbar flex w-full items-center gap-2 overflow-x-auto px-4 md:px-6"><SearchFilterTags activeTab={activeTab} setActiveTab={handleTabChange} /></div>;
    $[9] = activeTab;
    $[10] = handleTabChange;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = activeTab === "videos" ? videosTags : gamesTags;
  let t5;
  if ($[12] !== effectiveHiddenToolbar || $[13] !== filterModalTopOffset || $[14] !== t4) {
    t5 = <SearchToolbar hidden={effectiveHiddenToolbar} filterModalTopOffset={filterModalTopOffset} filterTags={t4} />;
    $[12] = effectiveHiddenToolbar;
    $[13] = filterModalTopOffset;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className="flex items-center justify-between py-4 max-md:flex-col max-md:gap-4">{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator className="bg-vive-surface-normal" />;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6) {
    t8 = <div className="bg-background sticky top-0 z-30 flex flex-col">{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== showGames || $[23] !== showTop) {
    t9 = showGames && <WorldsList contentType="games" enablePagination={!showTop} showNativeAd={showTop} />;
    $[22] = showGames;
    $[23] = showTop;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== showExperiences || $[26] !== showTop) {
    t10 = showExperiences && <WorldsList contentType="experiences" enablePagination={!showTop} showNativeAd={false} />;
    $[25] = showExperiences;
    $[26] = showTop;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== showTop || $[29] !== showVideos) {
    t11 = showVideos && <WorldsList contentType="videos" enablePagination={!showTop} showNativeAd={false} />;
    $[28] = showTop;
    $[29] = showVideos;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== showCreators || $[32] !== showTop) {
    t12 = showCreators && <CreatorsList enablePagination={!showTop} />;
    $[31] = showCreators;
    $[32] = showTop;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t9) {
    t13 = <div className="flex flex-1 flex-col gap-4 lg:gap-5">{t9}{t10}{t11}{t12}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== otherSearchedFor || $[40] !== showTop) {
    t14 = showTop && otherSearchedFor && otherSearchedFor.length > 0 && <OtherSearchedFor data={createSuggestionWorlds(otherSearchedFor)} />;
    $[39] = otherSearchedFor;
    $[40] = showTop;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t13 || $[43] !== t14) {
    t15 = <div className="flex flex-col p-4 lg:flex-row lg:gap-[10px] lg:p-6">{t13}{t14}</div>;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t15 || $[46] !== t8) {
    t16 = <div className="bg-background relative w-full">{t8}{t15}</div>;
    $[45] = t15;
    $[46] = t8;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  return t16;
}
export function SearchResultSkeleton() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="no-scrollbar flex w-full items-center gap-2 overflow-x-auto px-4 md:px-6"><div className="flex gap-2">{[1, 2, 3].map(_temp)}</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-background z-interactive sticky top-0 flex flex-col"><div className="flex items-center justify-between py-4">{t0}<div className="hidden items-center gap-3 px-4 md:px-6 lg:flex"><ViverseSkeleton className="h-10 w-24 rounded-full" /><ViverseSkeleton className="h-10 w-[88px] rounded-full" /></div></div><Separator className="bg-vive-surface-normal" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ViverseSkeleton className="h-6 w-24" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-4 lg:gap-5">{t2}<div className="flex flex-col gap-4 lg:gap-5">{[1, 2, 3].map(_temp2)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ViverseSkeleton className="h-6 w-24" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-1 flex-col gap-4 lg:gap-5">{t3}<div className="flex flex-col gap-4 lg:gap-5">{t4}<div className="flex flex-col gap-4 lg:gap-5">{[1, 2, 3].map(_temp3)}</div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-background relative w-full">{t1}<div className="flex flex-col p-4 lg:flex-row lg:gap-[10px] lg:p-6">{t5}<div className="hidden lg:block lg:w-[280px]"><ViverseSkeleton className="h-[400px] w-full rounded-lg" /></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp3(i_1) {
  return <RoomCardSkeleton key={i_1} />;
}
function _temp2(i_0) {
  return <CreatorCardSkeleton key={i_0} />;
}
function _temp(i) {
  return <ViverseSkeleton key={i} className="h-11 w-[100px] rounded-4xl" />;
}